import React from 'react';
import BenefitTrackerPage from './BenefitTrackerPage';

const ResourceEffectiveness = () => {
    return <BenefitTrackerPage benefitType='Resource Effectiveness' title="Resource Effectiveness" />;
};

export default ResourceEffectiveness;